module.exports = "/img/arrow-bottom.svg?7dd76e2a6efefe385f64c1b66b515ae0";